
import { useState, useEffect } from "react";
import { NewsArticle } from "../types";
import { getStoredArticles, saveArticles } from "../utils/newsStorage";

export const useNewsLoader = () => {
  const [articles, setArticles] = useState<NewsArticle[]>([]);

  // Load articles on initialization
  useEffect(() => {
    setArticles(getStoredArticles());
  }, []);

  // Save articles when they change
  useEffect(() => {
    if (articles.length > 0) {
      saveArticles(articles);
    }
  }, [articles]);

  return { articles, setArticles };
};
